import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'transfer-vertical', 'TransferVertical', [["path",{"d":"M10 4v16l-6 -5.5"}],["path",{"d":"M14 20v-16l6 5.5"}]]);